const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
		loadingFlag: false,
		form: {
			content: '',
			phone: '',
		}
	},
	computed: {
		length() {
			return this.form.content.length;
		}
	},
	methods: {
		submitInfo() {
			if (this.loadingFlag) {
				return;
			}
			// 内容
			if (this.form.content.trim() == '') {
				alert('请输入您要反馈的问题!');
				return;
			}
			// 手机号验证
			if (!this.isPhoneNumber(this.form.phone)) {
				alert('请输入正确的手机号码!');
				return;
			}
			this.loadingFlag = true;
			axios.post(baseURL + 'addFeedback?content=' + this.form.content + '&name=' + this.form.name + '&phone=' + this.form.phone)
				.then(res => {
					this.loadingFlag = false;
					if (res.code == 200) {
						alert('反馈成功!');
						this.form.content = '';
						this.form.phone = '';
					} else {
						alert(res.msg);
					}
				})
				.catch(err => console.log(err));
		}
	}
});